'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import { useCallback, useEffect, useState } from 'react';
import { toStorefrontMediaUrl } from '@/lib/media-url';
import type { LightboxGalleryBlock } from '../types';
import { RichSegments } from './RichSegments';
import styles from './LightboxGallery.module.css';
interface LightboxGalleryProps {
  block: LightboxGalleryBlock;
  blockId: string;
}
export function LightboxGallery(t0) {
  const $ = _c(29);
  const {
    block,
    blockId
  } = t0;
  const [openIndex, setOpenIndex] = useState(null);
  const columns = block.columns ?? 3;
  const layoutClass = block.layout === "inline" ? styles.inline : block.layout === "slick" ? styles.slick : styles.grid;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpenIndex(null);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const close = t1;
  let t2;
  if ($[1] !== block.items.length) {
    t2 = () => {
      setOpenIndex(prev => {
        if (prev === null) {
          return prev;
        }
        return (prev + 1) % block.items.length;
      });
    };
    $[1] = block.items.length;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const next = t2;
  let t3;
  if ($[3] !== block.items.length) {
    t3 = () => {
      setOpenIndex(p => {
        if (p === null) {
          return p;
        }
        return (p - 1 + block.items.length) % block.items.length;
      });
    };
    $[3] = block.items.length;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const prev_0 = t3;
  let t4;
  let t5;
  if ($[5] !== next || $[6] !== openIndex || $[7] !== prev_0) {
    t4 = () => {
      if (openIndex === null) {
        return;
      }
      const onKey = function onKey(e) {
        if (e.key === "Escape") {
          close();
        } else {
          if (e.key === "ArrowRight") {
            next();
          } else {
            if (e.key === "ArrowLeft") {
              prev_0();
            }
          }
        }
      };
      window.addEventListener("keydown", onKey);
      return () => window.removeEventListener("keydown", onKey);
    };
    t5 = [openIndex, close, next, prev_0];
    $[5] = next;
    $[6] = openIndex;
    $[7] = prev_0;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== block.layout || $[11] !== columns) {
    t6 = block.layout !== "inline" && block.layout !== "slick" ? {
      gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`
    } : undefined;
    $[10] = block.layout;
    $[11] = columns;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== block.items) {
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = (item, idx) => <a key={item.id ?? idx} href={toStorefrontMediaUrl(item.full.src)} target="_blank" rel="noopener noreferrer" className={styles.thumbButton} onClick={event => {
        event.preventDefault();
        setOpenIndex(idx);
      }} aria-label={`Open image ${idx + 1} in lightbox`}><img src={toStorefrontMediaUrl(item.thumb.src)} alt={item.thumb.alt} loading="lazy" className={styles.thumb} />{item.caption && item.caption.length > 0 ? <span className={styles.caption}><RichSegments segments={item.caption} /></span> : null}</a>;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    t7 = block.items.map(t8);
    $[13] = block.items;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[16] !== layoutClass || $[17] !== t6 || $[18] !== t7) {
    t8 = <div className={layoutClass} style={t6}>{t7}</div>;
    $[16] = layoutClass;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== block.items || $[21] !== next || $[22] !== openIndex || $[23] !== prev_0) {
    t9 = openIndex !== null && block.items[openIndex] ? <div role="dialog" aria-modal={true} className={styles.overlay} onClick={close}><button type="button" className={styles.closeBtn} onClick={close} aria-label="Close lightbox">×</button>{block.items.length > 1 ? <button type="button" className={styles.prevBtn} onClick={e_0 => {
        e_0.stopPropagation();
        prev_0();
      }} aria-label="Previous image">‹</button> : null}<img src={toStorefrontMediaUrl(block.items[openIndex].full.src)} alt={block.items[openIndex].full.alt} className={styles.fullImage} onClick={_temp} />{block.items.length > 1 ? <button type="button" className={styles.nextBtn} onClick={e_2 => {
        e_2.stopPropagation();
        next();
      }} aria-label="Next image">›</button> : null}</div> : null;
    $[20] = block.items;
    $[21] = next;
    $[22] = openIndex;
    $[23] = prev_0;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== blockId || $[26] !== t8 || $[27] !== t9) {
    t10 = <div className={styles.wrapper} data-cms-block-id={blockId} data-cms-field="lightboxGallery">{t8}{t9}</div>;
    $[25] = blockId;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}
function _temp(e_1) {
  return e_1.stopPropagation();
}